var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 26C7.12139 26 6 24.8786 6 23.5C6 22.1214 7.12139 21 8.5 21C9.87861 21 11 22.1214 11 23.5C11 24.8786 9.87861 26 8.5 26ZM8.5 24.3333C8.95944 24.3333 9.33333 23.9594 9.33333 23.5C9.33333 23.0406 8.95944 22.6667 8.5 22.6667C8.04056 22.6667 7.66667 23.0406 7.66667 23.5C7.66667 23.9594 8.04056 24.3333 8.5 24.3333Z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 21C19.8786 21 21 22.1214 21 23.5C21 24.8786 19.8786 26 18.5 26C17.1214 26 16 24.8786 16 23.5C16 22.1214 17.1214 21 18.5 21ZM18.5 22.6667C18.0406 22.6667 17.6667 23.0406 17.6667 23.5C17.6667 23.9594 18.0406 24.3333 18.5 24.3333C18.9594 24.3333 19.3333 23.9594 19.3333 23.5C19.3333 23.0406 18.9594 22.6667 18.5 22.6667Z",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35416 16.5698C4.16162 14.738 2.91422 2.87805 2.80183 1.80952H0.903914C0.404652 1.80952 0 1.40449 0 0.904762C0 0.405032 0.404652 0 0.903914 0H3.61566C4.07816 0 4.46594 0.34954 4.51475 0.810365L4.90494 4.52381H24.1915C24.7398 4.52381 25.2521 4.7687 25.597 5.19575C25.9423 5.62249 26.0743 6.1753 25.9595 6.71243L23.7883 16.8542C23.5217 18.0973 22.4068 19 21.1365 19H7.05113C5.65911 19 4.49969 17.9553 4.35416 16.5698ZM22.0206 16.4751L24.1912 6.33333H5.09537L6.15204 16.3807C6.20055 16.8424 6.58682 17.1905 7.05113 17.1905H21.1365C21.5596 17.1905 21.9314 16.8895 22.0206 16.4751Z",
    fill: "#6D6D6D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.f1d4b61e.svg";
export { ForwardRef as ReactComponent };